/**
 * Require styles, assets, and template files. This helps mark these files for
 * webpack so it knows they are dependencies that should be copied over.
 */

require('../scss/blog.scss');
require.context('../../', true, /\.(jpg|png|gif|svg)$/);
require.context('../../', true, /\.(eot|ttf|woff)$/);
require.context('../../', true, /\.hbs$/);

/**
 * Require js files
 */

import 'es6-promise/auto';

import React from 'react';
import ReactDOM from 'react-dom';
import ui from '@watsi/ui';

import ready from 'domready';
import fitvids from 'fitvids';
import clamp from 'clamp-js';

import BlogSubscribeFooterUpsell from './components/BlogSubscribeFooterUpsell';

import track from './lib/segment';
import popup from './lib/popup';

const Footer = ui.components.Footer;
const $ = selector => Array.from(document.querySelectorAll(selector));

ready(function () {
  // Track Segment pagse events
  track();

  // Resize videos
  fitvids();

  // Clamp line count for post previews
  $('.js-clamp').forEach(el => {
    clamp(el, { clamp: 4 });
  });

  // Make social buttons pop-up in a new window
  popup($('.js-socialButton'), { height: 257, width: 500 });

  // All blog links should open in new tab
  $('.BlogPostContent a').forEach(el => {
    el.setAttribute('target', '_blank');
  });

  // Init subscribe footer upsell
  $('.js-subscribeSection').forEach(el => {
    ReactDOM.render(<BlogSubscribeFooterUpsell />, el);
  });

  $('.js-footer').forEach(el => {
    ReactDOM.render(<Footer isExternalDomain emailAddress="connect@watsi.org" />, el);
  });
});
